import MoreVertIcon from '@mui/icons-material/MoreVert';
import IconButton from '@mui/material/IconButton';
import { Theme } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import MenuPageHeaderActionsRaw from './MenuPageHeaderActionsRaw/MenuPageHeaderActionsRaw';

const useStyles = makeStyles()((theme: Theme) => ({
    button: {
        [theme.breakpoints.up(0)]: {
            padding: '3px',
            fontSize: '1.125rem',
        },
        [theme.breakpoints.up('md')]: {
            padding: '8px',
            fontSize: '1.5rem',
        },
        '& .MuiSvgIcon-root': {
            fill: theme.palette.appHeader.contrastText,
        },
    },
}));

interface Props {
    onOpenDialogHandler: (event: React.MouseEvent<HTMLElement>) => void;
}

export default function MenuPageHeaderActions({ onOpenDialogHandler }: Props) {
    const { classes } = useStyles();

    const [menuId] = React.useState<string>('menu_global_actions');

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <React.Fragment>
            <Tooltip title="Menu">
                <IconButton
                    onClick={handleOpen}
                    aria-haspopup="true"
                    aria-controls={menuId}
                    aria-expanded={Boolean(anchorEl)}
                    className={classes.button}
                    size="large"
                >
                    <MoreVertIcon />
                </IconButton>
            </Tooltip>
            {Boolean(anchorEl) && (
                <MenuPageHeaderActionsRaw
                    anchorEl={anchorEl}
                    menuId={menuId}
                    onOpenDialogHandler={onOpenDialogHandler}
                    onCloseHandler={handleClose}
                />
            )}
        </React.Fragment>
    );
}
